<template>
  <div class="main-content-container">
    <div
      class="top-content-container position-relative customer-details-top-content"
    >
      <b-row>
        <b-col md="6" cols="12">
          <b-breadcrumb class="customer-breadcrumbs">
            <b-breadcrumb-item v-if="showPABreadcrumb">
              <span
                @click="$router.push({ name: 'ViewPADirectory' })"
                class="text-uppercase font-family-medium"
              >
                Team Directory
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item v-if="showPABreadcrumb">
              <span
                @click="goToPAContactInfo"
                class="text-uppercase font-family-medium"
              >
                {{ assistantFullName }}
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item>
              <span
                @click="navigateToCustomers"
                class="text-uppercase font-family-medium"
              >
                Customers
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>
              <span class="text-uppercase font-family-medium">
                {{ customerFirstName }} {{ customerLastName }}
              </span>
            </b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>
        <b-col md="12" cols="12" class="mr-4">
          <!-- Show top skeleton loader -->
          <div
            v-if="showTopSkeletonLoader"
            class="user-info-right d-flex customer-details-user-info"
          >
            <div
              class="d-flex position-relative user-info-right-container-skeleton"
            >
              <b-skeleton type="avatar" size="8rem"></b-skeleton>

              <div
                class="user-info-content d-flex flex-column position-relative"
              >
                <b-skeleton width="150%"></b-skeleton>
                <b-skeleton class="mt-3" width="200%"></b-skeleton>
                <div class="d-flex mt-4">
                  <b-skeleton
                    v-for="index in 2"
                    :key="index"
                    class="mr-2 btn-pill"
                    width="5rem"
                    height="2rem"
                  >
                  </b-skeleton>
                </div>
              </div>
            </div>

            <div
              class="d-xl-flex d-lg-flex d-md-flex d-none ml-5 align-items-center"
            >
              <b-skeleton type="avatar" size="4.4rem"></b-skeleton>
              <div class="ml-3 mt-3">
                <b-skeleton width="10rem"></b-skeleton>
                <b-skeleton class="mt-3" width="12rem"></b-skeleton>
              </div>
            </div>
          </div>
          <!-- End top skeleton loader -->

          <div
            v-if="!showTopSkeletonLoader"
            class="user-info-right d-flex customer-details-user-info"
          >
            <div class="d-flex position-relative user-info-right-container">
              <b-avatar
                v-if="customerAvatar"
                size="8rem"
                :src="customerAvatar"
              ></b-avatar>
              <b-avatar
                v-else
                size="8rem"
                class="bg--primary"
                :text="customerInitials"
              ></b-avatar>
              <div
                class="user-info-content d-flex flex-column position-relative"
              >
                <p class="font-family-medium primary--text">
                  {{ customerFullName }}
                </p>
                <p class="secondary--text reduce-whitespace">
                  {{ customerMail }}
                </p>
                <div class="d-flex">
                  <b-button
                    class="reduce-whitespace-2 text-uppercase mr-2 btn-chip btn-danger--light danger font-family-regular btn-chip--pill"
                    >{{ customerMembership }}</b-button
                  >
                </div>
              </div>
            </div>
            <span
              v-if="assistantUser"
              class="position-relative d-none d-sm-none d-md-none d-lg-inline-block d-xl-inline-block vertical-border"
            ></span>
            <div
              v-if="assistantUser"
              class="d-xl-flex d-lg-flex d-md-flex d-none ml-5 align-items-center"
            >
              <b-avatar
                v-if="assistantAvatar"
                size="4.4rem"
                :src="assistantAvatar"
              ></b-avatar>

              <b-avatar
                :text="assistantInitials"
                size="4.4rem"
                class="assigned-pa-avatar bg--primary"
                v-else
              ></b-avatar>
              <div class="d-flex flex-column ml-3 mt-3 assistant-details">
                <h6 class="font-sm secondary--text">Assigned EA</h6>
                <p class="font-family-medium primary--text reduce-whitespace">
                  {{
                    assistantFullName.length > 15
                      ? `${assistantFullName.substring(0, 15)}...`
                      : assistantFullName
                  }}
                </p>
              </div>
            </div>
          </div>
        </b-col>
        <b-col class="d-lg-none d-xl-none d-md-none d-sm-flex d-flex mt-4 px-0">
          <div class="d-flex ml-5 align-items-center">
            <b-avatar
              v-if="assistantAvatar !== null && assistantUser"
              size="4.4rem"
              :src="assistantAvatar"
            ></b-avatar>

            <b-avatar
              :text="assistantInitials"
              size="4.4rem"
              class="assigned-pa-avatar bg--primary"
              v-if="assistantAvatar === null && assistantUser"
            ></b-avatar>
            <div v-if="assistantUser" class="d-flex flex-column ml-3">
              <label class="font-sm secondary--text">Assigned EA</label>
              <h4 class="font-md font-family-medium primary--text">
                {{
                  assistantFullName.length > 15
                    ? `${assistantFullName.substring(0, 15)}...`
                    : assistantFullName
                }}
              </h4>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-tabs
      v-model="tabIndex"
      @input="setActiveTab"
      class="customer-details-tabs"
      style="height:80%"
      active-nav-item-class="danger"
      active-tab-class="text-success"
    >
      <b-tab title="Tasks" style="height:100%">
        <CustomerTasks v-if="tabIndex == 0" />
      </b-tab>
      <b-tab title="Preferences">
        <CustomerPreferences />
      </b-tab>
      <b-tab title="Contact Information">
        <CustomerContact
          v-on:updateAvatar="updateCustomerAvatar"
          v-on:updateCustomerDetails="updateCustomerDetails"
          v-on:updateMembership="updateCustomerMembership"
        />
      </b-tab>
      <b-tab title="Weekly">
        <CustomersWeekly :customerFullName="customerFullName" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import CustomerContact from "./contact/CustomerContact";
import CustomerPreferences from "./preferences/CustomerPreferences";
import CustomerTasks from "./tasks/CustomerTasks";
import CustomersWeekly from "./weekly/CustomersWeekly";

import { getAssignedAssistantsList, getCustomer } from "@/apis/customers/index";
import { mapState } from "vuex";
export default {
  name: "CustomerDetails",
  components: {
    CustomerContact,
    CustomerPreferences,
    CustomerTasks,
    CustomersWeekly
  },
  computed: {
    ...mapState("authModule", ["role"])
  },
  data() {
    return {
      prevRouteParams: {},
      showPABreadcrumb: null,
      tabIndex: 2,
      customerID: "",
      customerAvatar: null,
      assistantAvatar: null,
      customerFullName: "",
      customerInitials: "",
      customerUser: null,
      assistantUser: null,
      assistantFullName: "",
      assistantInitials: "",
      customerFirstName: "",
      customerLastName: "",
      assistantFirstName: "",
      assistantLastName: "",
      customerMail: "",
      assistantList: [],
      assistantProfileId: "",
      isSelf: null,
      showTopSkeletonLoader: true,
      customerMembership: ""
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name === "PADetails") {
        vm.showPABreadcrumb = true;
        vm.prevRouteParams = from.params;
      }
    });
  },
  created() {
    if (this.$route.name === "PACustomerDetails") {
      this.showPABreadcrumb = true;
    }
    const { tab } = this.$route.query;
    this.tabIndex = Number(tab);
    if (this.tabIndex === 1) {
      this.trackView();
    }
  },
  mounted() {
    this.getDetails();
  },
  watch: {
    $route(to) {
      if (to.query && to.query.tab) {
        this.tabIndex = Number(to.query.tab);
      }
    }
  },
  methods: {
    trackView() {
      this.$gtag.event("Preferences - List", {
        event_category: "feature"
      });
    },
    updateCustomerAvatar(avatar) {
      this.customerAvatar = avatar;
    },
    updateCustomerDetails(details) {
      this.customerFirstName = details.firstName;
      this.customerLastName = details.lastName;
      this.customerFullName = `${details.firstName} ${details.lastName}`;
      this.customerMail = details.email;
    },
    updateCustomerMembership(membership) {
      this.customerMembership = membership;
    },
    setActiveTab() {
      if (this.$route.name === "CustomerDetails") {
        this.$router.push({
          params: {
            profileId: this.$route.params.profileId
          },
          name: "CustomerDetails",
          query: {
            tab: this.tabIndex
          }
        });
      } else if (this.$route.name === "PACustomerDetails") {
        this.$router.push({
          params: {
            profileId: this.$route.params.profileId,
            uuid: this.$route.params.uuid
          },
          name: "PACustomerDetails",
          query: {
            tab: this.tabIndex
          }
        });
      }
    },
    getAssistantDetails() {
      this.customerID = this.$route.params.profileId;
      getAssignedAssistantsList(this.customerID).then(res => {
        let defaultAssistant = res.data.results.find(
          assistant => assistant.isDefault
        );
        let {
          firstName,
          lastName,
          avatar
        } = defaultAssistant.assistant.profile.user;
        this.assistantFirstName = firstName;
        this.assistantLastName = lastName;
        this.assistantAvatar = avatar;
        this.assistantUser = res.data.results[0]?.assistant.profile.user;
        this.assistantFullName = `${this.assistantFirstName} ${this.assistantLastName}`;
        this.assistantInitials = this.assistantFullName
          .match(/\b(\w)/g)
          .join("");
      });
    },
    async getCustomerDetails() {
      this.customerID = this.$route.params.profileId;
      await getCustomer(this.customerID)
        .then(res => {
          this.customerFirstName = res.data.user.firstName;
          this.customerLastName = res.data.user.lastName;
          this.customerFullName = `${res.data.user.firstName} ${res.data.user.lastName}`;
          this.customerInitials = this.customerFullName
            .match(/\b(\w)/g)
            .join("");
          this.customerAvatar = res.data.user.avatar;
          this.customerMail = res.data.user.email;
          this.customerUser = res.data.user;
          this.customerMembership = res.data.profile.membership
            ? res.data.profile.membership.title
            : "N/A";
        })
        .catch(err => {
          if (err.message.includes("code 403")) {
            this.$router.push({
              name: "403",
              params: {
                message: "You don't have permission to access this task",
                code: "403"
              }
            });
          } else {
            this.$router.push({
              name: "404",
              params: {
                message: "This customer does not exist",
                code: "404"
              }
            });
          }
        });
    },
    getDetails() {
      const assistantDetails = this.getAssistantDetails();
      const customerDetails = this.getCustomerDetails();
      Promise.allSettled([assistantDetails, customerDetails])
        .then(() => {})
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showTopSkeletonLoader = false;
        });
    },
    navigateToCustomers() {
      if (this.$route.params.uuid) {
        this.$router.go(-1);
      } else {
        if (this.role === "assistant") {
          this.$router.push({ name: "DedicatedCustomers" });
        } else if (this.role === "admin") {
          this.$router.push({ name: "CustomersListAdmin", query: { tab: 0 } });
        }
      }
    },
    goToPAContactInfo() {
      this.$router.push({
        name: "PADetails",
        params: {
          profileId: this.$route.params.profileId,
          uuid: this.$route.params.uuid
        },
        query: {
          tab: 1
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.user-info-right {
  justify-content: flex-end;
}
.user-info-right-container {
  right: 8rem;
}
.user-info-right-container-skeleton {
  right: 18rem;
}
.user-info-content {
  left: 2rem;
}
.vertical-border {
  border-left: 1px solid rgb(132 155 165 / 0.2);
  right: 1rem;
}
.tab-content {
  height: 90%;
}
.assistant-details {
  margin-top: 0 !important;
}
.assistant-details h6,
.assistant-details p {
  margin: unset;
  line-height: 1.8rem;
}

@media screen and (max-width: 991px) {
  .user-info-right.customer-details-user-info {
    justify-content: flex-start;
  }
  .user-info-right-container {
    right: 0;
  }
}
</style>
